import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children, rolMinimo, seccion, modulo, soloAdminGlobal }) {
  const { usuario, cargando, rolActual, seccionesDeshabilitadas, esAdminGlobal, modulosActivos } = useAuth();
  const location = useLocation();
  // Al cambiar de empresa desde el selector, si esta pantalla no aplica a la
  // nueva empresa se va al inicio en vez de mostrar el aviso.
  const empresaCambiada = !!location.state?.empresaCambiada;

  if (cargando) {
    return <div className="flex h-screen items-center justify-center text-slate-500">Cargando...</div>;
  }

  if (!usuario) {
    return <Navigate to="/login" replace />;
  }

  if (soloAdminGlobal && !esAdminGlobal) {
    return <div className="p-8 text-center text-red-600">Solo administradores pueden ver esta sección.</div>;
  }

  if (seccion && seccionesDeshabilitadas.includes(seccion)) {
    return <div className="p-8 text-center text-red-600">No tienes permiso para ver esta sección.</div>;
  }

  if (modulo && !modulosActivos?.[modulo]) {
    if (empresaCambiada) return <Navigate to="/" replace />;
    return <div className="p-8 text-center text-red-600">Este módulo no está habilitado para esta empresa.</div>;
  }

  const jerarquia = ['consultor', 'operador', 'contador', 'gerente', 'admin'];
  if (rolMinimo && jerarquia.indexOf(rolActual) < jerarquia.indexOf(rolMinimo)) {
    if (empresaCambiada) return <Navigate to="/" replace />;
    return <div className="p-8 text-center text-red-600">No tienes permisos para ver esta sección.</div>;
  }

  return children;
}
